<template>
  <hic-dialog title="生命体征编辑" :visible="visible" @open="open" @close="$emit('update:visible', false)" width="30rem">
    <h3 class="center info">
      <span>
        <span>床位：{{ value.bedNo }}</span>
        <span class="left-pad">姓名：{{ value.patientName }}</span>
      </span>
    </h3>
    <el-form label-width="8rem" size="small">
      <el-form-item label="体温">
        <el-input v-model="value.temperature" v-hic-select @keyup.enter.native="focusNext('temperature')" ref="temperature"><span slot="suffix">℃</span></el-input>
      </el-form-item>
      <el-form-item label="脉搏">
        <el-input v-model="value.pulse" v-hic-select @keyup.enter.native="focusNext('pulse')" ref="pulse"><span slot="suffix">次 / 分</span></el-input>
      </el-form-item>
      <el-form-item label="呼吸">
        <el-input v-model="value.respiration" v-hic-select @keyup.enter.native="focusNext('respiration')" ref="respiration"><span slot="suffix">次 / 分</span></el-input>
      </el-form-item>
      <el-form-item label="血压">
        <el-input v-model="value.bloodPressure" v-hic-select @keyup.enter.native="focusNext('bloodPressure')" ref="bloodPressure"><span slot="suffix">mmHg</span></el-input>
      </el-form-item>
      <el-form-item label="血糖">
        <el-input v-model="value.bloodGlucose" v-hic-select @keyup.enter.native="focusNext('bloodGlucose')" ref="bloodGlucose"><span slot="suffix">mmol / L</span></el-input>
      </el-form-item>
      <el-form-item label="特殊原因">
        <hic-dict-selector v-model="value.reason" dict-type="VitalSignReason"></hic-dict-selector>
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="value.memo" type="textarea"></el-input>
      </el-form-item> 
      <el-form-item label="时间">
        <el-date-picker v-model="value.execTime" type="datetime" placeholder="选择日期时间" style="width: 100%" :picker-options="$utils.Dt.picker(['今天', '昨天', '前天'], '<=')" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
      </el-form-item>
    </el-form>

    <template #footer>
      <el-button type="info" @click="$emit('update:visible', false)">关 闭</el-button>
      <el-button type="primary" @click="save" ref="saveButton">保 存</el-button>
    </template>
  </hic-dialog>
</template>
<script>
  import api from "./api";

  export default {
    props: {
      visible: Boolean,
      value: Object,
    },

    methods: {
      open() {
        this.$nextTick(() => {
          this.$refs.temperature.focus();
        });
      },
      save() {
        for (const prop of ["temperature", "pulse", "respiration", "bloodPressure", "bloodGlucose", "reason"]) {
          if (!!this.value[prop]) {
            api.VitalSigns.save(this.value)
              .then((res) => {
                this.$emit("saved", res);
                this.$emit("update:visible", false);
              })
              .catch((err) => {
                console.log(err);
                this.$message.error(err.message || err);
              });
            return;
          }
        }
        this.$message.warning("请填写体征或选择特殊原因！");
        this.$refs.temperature.focus();
      },

      focusNext(refName) {
        const next = ["temperature", "pulse", "respiration", "bloodPressure", "bloodGlucose"];
        const index = next.indexOf(refName);
        if (index < next.length - 1) {
          this.$refs[next[index + 1]].focus();
          return;
        }
        this.$refs["saveButton"].$el.focus();
      },
    },
  };
</script>
